import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';
import { type FC, type PropsWithChildren, useEffect } from 'react';

import PosthogPageView from './PosthogPageView';

// TODO: maybe move this to secrets manager in AWS
// but not required, as these are not secrets
// and are ok to be exposed publicly
const VITE_PUBLIC_POSTHOG_KEY =
  'phc_FFydM7PKv9kjGULgN3J3CQ9xGoICZZXXkoqnL2czEmH';
// Route analytics through our own domain (CNAME -> PostHog EU managed reverse
// proxy) so ad-blockers don't drop events/recordings. `ui_host` keeps PostHog
// UI links (toolbar, etc.) pointing at the real instance.
const VITE_PUBLIC_POSTHOG_HOST = 'https://e.autone.io';
const VITE_PUBLIC_POSTHOG_UI_HOST = 'https://eu.posthog.com';

const PostHogProvider: FC<PropsWithChildren> = ({ children }) => {
  const env =
    import.meta.env.MODE === 'development'
      ? 'localhost'
      : import.meta.env.VITE_BUILD_STAGE;

  const shouldUsePosthog = env === 'production';

  useEffect(() => {
    if (VITE_PUBLIC_POSTHOG_KEY && shouldUsePosthog) {
      posthog.init(VITE_PUBLIC_POSTHOG_KEY, {
        disable_surveys: true,
        api_host: VITE_PUBLIC_POSTHOG_HOST,
        ui_host: VITE_PUBLIC_POSTHOG_UI_HOST,
        persistence: 'localStorage+cookie',
        // Disable automatic pageview capture, as we capture manually
        capture_pageview: false,
      });
    }
  }, []);

  if (!shouldUsePosthog) {
    return children;
  }

  return (
    <PHProvider client={posthog}>
      <PosthogPageView />
      {children}
    </PHProvider>
  );
};

export default PostHogProvider;
